import React, { useState } from 'react';
import { useEffect } from 'react';


const Navbar = ({ userInfo, SetOpen, SignOutAccount }) => {
    const [navStyle, setNavStyle] = useState(false)

    const ChangeNav = () => {
        if (window.scrollY >= 80) {
            setNavStyle(true)
        } else {
            setNavStyle(false)
        }
    }

    useEffect(() => {
        window.addEventListener('scroll', ChangeNav);
    }, [])


    return (
        <div className={`py-3 navBarStyle ${navStyle ? 'navbar_main_container' : ''}`}>
            <nav className={`container navbar navbar-expand-lg navbar-dark`}>
                <div className="container-fluid">
                    <a className="navbar-brand text-2xl" href="#">Tajuud<span className='navbar_brand_color'>din</span> Tar<span className='navbar_brand_color'>ek</span></a>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                            <li className="nav-item">
                                <a className="nav-link" aria-current="page" href="#">Home</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="#skills">Skills</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="#projects">Projects</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="#about">About</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="#blogs">Blogs</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="#contact">Contact</a>
                            </li>
                            {
                                userInfo ?
                                <>
                                    <li className="nav-item navbar_large">
                                        <button onClick={SignOutAccount} className="nav-link navbar_btn">Sign Out</button>
                                    </li>
                                    <li className="nav-item navbar_medium">
                                        <span onClick={SignOutAccount} className="nav-link">Sign Out</span>
                                    </li>
                                </> :
                                <>
                                    <li className="nav-item navbar_large">
                                        <button onClick={() => SetOpen(true)} className="nav-link navbar_btn">Login Or Signup</button>
                                    </li>
                                    <li className="nav-item navbar_medium">
                                        <span onClick={() => SetOpen(true)} className="nav-link">Login Or Signup</span>
                                    </li>
                                </>
                            }
                        </ul>
                    
                    </div>
                </div>
            </nav>
        </div>
    );
};

export default Navbar;